// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__1B0jJ","back_ground":"App_back_ground__2BbNh","logoBack":"App_logoBack__1RT-j"};